import $ from 'jquery'
import manager from '../manager'
import EventBus from '@/utils/iframe-eventbus'
import { isEditorPage } from '@/utils/page'
import _ from 'lodash'

manager.add('navigation', {
	created(evenType) {
		let $dom = $(this.dom)
		let $window = $(window)
		let self = this
		this.evenType = evenType || 'click'
		this.type = $dom.attr('data-type');

		$dom.on('click', '.J_tab-header', function () {
			EventBus.dispatch("activeModule", { instanceId: self.instanceId, flag: "Navigation" })
		})
		$dom.on(this.evenType, '.J_tab-header li', function () {
			EventBus.dispatch("tabModule/change", {
				id: self.instanceId,
				index: $(this).index()
			})
			if (isEditorPage()) {
				return;
			}
			const targetModule = self.getTargetModule(this)
			if (!targetModule) {
				return
			}
			const offsetTop = $(targetModule).offset().top;
			self.scrollTo(offsetTop)
		})
		let tabs = $dom.find('.J_tab-header li').map(function () {
			return self.getTargetModule(this)
		})
		//g跟随逻辑
		this.onWindowScroll = _.throttle(() => {
			if (this.isScrolling) {
				return
			}
			let a = $window.scrollTop()
			let ah = $window.height()
			//目标模块相对于窗口的比例
			let prefactor = 0
			//用占比最大的模块来确定新的tab
			let index = 0
			tabs.each(function (i) {
				let n = $(this).offset().top
				let nh = $(this).height()
				if (a + ah < n || a > n + nh) {
					return 0
				}
				let sorted = [a, a + ah, n, n + nh]
				sorted.sort((a, b) => a - b)
				let factor = (sorted[2] - sorted[1]) / ah
				if (factor > prefactor) {
					prefactor = factor
					index = i
				}
			})
			if (!prefactor > 0) {
				return
			}
			this.onTab({
				target: {
					index,
					id: self.instanceId
				}
			})
		}, 50)
		if (!isEditorPage()) {
			$window.on("scroll", this.onWindowScroll)
		}
		this.onTab({
			target: {
				index: 0,
				id: this.instanceId
			}
		})
		EventBus.addEventListener("tabModule/change", this.onTab.bind(this))
	},
	destroyed() {
		$(this.dom).off('click', '.J_tab-header')
		$(this.dom).off(this.evenType, '.J_tab-header li')
		$(window).off("scroll", this.onWindowScroll)
		EventBus.removeEventListener("tabModule/change", this.onTab)
	},
	getTargetModule(dom) {
		const classArray = [...dom.classList];
		const prefix = 'selected-module-id';
		const moduleIdInfo = classArray[1].includes(prefix) ? classArray[1] : null;
		if (!moduleIdInfo) {
			return
		}
		let moduleId = moduleIdInfo.split('-').pop();
		return document.body.querySelector(`[instanceid="${moduleId}"]`);
	},
	scrollTo(offsetTop) {
		this.isScrolling = true
		let $dom = $(this.dom)
		const domOffsetTop = $dom.closest('.j-module').offset().top;
		const domHeight = $dom.height();
		let scrolledTop;
		if (offsetTop > domOffsetTop) {
			//由于吸顶，当目标模块位于导航模块下方时需要减去导航模块高度
			scrolledTop = offsetTop - domHeight;
		} else {
			//目标模块位于导航模块上方时，不会触发吸顶，所以不减
			scrolledTop = offsetTop;
		}
		$('html, body').animate({
			scrollTop: scrolledTop
		}, 300, () => {
			this.isScrolling = false
		});
	},
	onTab(e) {
		let tabs = $(this.dom).find(".J_tab-header li")
		if (e.target.id != this.instanceId) return
		var tab = tabs.eq(e.target.index)
		this.moveTabToCenter(tab)
		tab.addClass('active').siblings('li').removeClass('active')
		if (this.type === 'image') {
			let $img = tab.find('img');
			let selectImage = $img.attr('data-select');
			$img.attr('src', selectImage);
			tab.siblings('li').each(function () {
				let $img = $(this).find('img');
				let defaultImage = $img.attr('data-default');
				$img.attr('src', defaultImage)
			})
		}
	},
	moveTabToCenter:_.debounce(function(tab) {
		let box=$(this.dom).find(".J_tab-header ul")
		let left=box.scrollLeft()-(box.width()/2-tab.width()/2-tab.offset().left)
		box.animate({
			scrollLeft:left
		},100)
	},100)
})
